module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/banner01_sp-4e6e2b2444f9898e20fa82f64a49d02b.png";